import { Fragment } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { IoMdLogOut } from "react-icons/io";
import { AiFillHome } from "react-icons/ai";
import {
  Divider,
  MenuItem as MuiMenuItem,
  ListItemIcon,
  Typography,
} from "@mui/material";

import pages from "../../../../constants/pages";
import { signOutMember } from "../../../../redux/slices/memberSlice";
import { colors } from "../../../../pages/css components/Style";
import dashboardLayoutRoutes from "../../../../router/router components/dashboardLayoutRoutes";
import ENV from "../../../../config/config";

const MenuItem = styled(MuiMenuItem)`
  min-width: 200px;
`;

export default function DropDownMenu({ role, setMenuAnchor }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { agencyID, activeBrand } = useSelector((state) => state.memberDetails);

  return (
    <Fragment>
      {((role === "NORMAL_USER" && agencyID === null) ||
        (role === "AGENCY" && !!agencyID)) && (
        <>
          <MenuItem
            onClick={() => {
              setMenuAnchor(null);
              if (role === "AGENCY") {
                navigate(
                  dashboardLayoutRoutes.agencyDetailsRoute.path +
                    "?agencyID=" +
                    agencyID
                );
              }

              if (role === "NORMAL_USER") {
                navigate(pages.brandDetails.route);
              }
            }}
          >
            <ListItemIcon>
              <AiFillHome color={"#5e5e5e"} fontSize="medium" />
            </ListItemIcon>
            <Typography variant="h6" color={"#5e5e5e"}>
              Home
            </Typography>
          </MenuItem>
          <Divider style={{ marginBlock: 7 }} />
        </>
      )}

      {/* {((role === "NORMAL_USER" && agencyID === null) ||
        (role === "AGENCY" && !!agencyID)) && (
        <> */}
      <MenuItem
        onClick={() => {
          setMenuAnchor(null);
          setMenuAnchor(null);
          let route =
            pages.profilePage.route +
            "?brandID=" +
            activeBrand.ID +
            "&withCompany=" +
            true;
          navigate(route);
        }}
      >
        <ListItemIcon>
          <FaUserCircle color={"#5e5e5e"} fontSize="medium" />
        </ListItemIcon>

        <Typography variant="h6" color={"#5e5e5e"}>
          Profile
        </Typography>
      </MenuItem>
      <Divider style={{ marginBlock: 7 }} />
      {/* </>
      )} */}

      <MenuItem
        onClick={() => {
          dispatch(signOutMember());
          if (ENV === "dev") {
            window.location = "https://buz.igrowthos.ai/";
          }

          if (ENV === "main") {
            window.location = "https://www.growthosin.ai";
          }
        }}
      >
        <ListItemIcon>
          <IoMdLogOut color={"#5e5e5e"} fontSize="medium" />
        </ListItemIcon>

        <Typography variant="h6" color={"#5e5e5e"}>
          Logout
        </Typography>
      </MenuItem>
    </Fragment>
  );
}
